import { FC } from 'react';
import { AIMessage, Message } from './Message';

import styles from './Messages.module.scss';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export interface MessagesProps {
  threadId: string;
  messagesFromThread: AIMessage[];
  isLoading: boolean;
}

export const Messages: FC<MessagesProps> = ({
  messagesFromThread,
  threadId,
  isLoading
}) => {
  if (isLoading) {
    return (
      <div className={styles['loadingContainer']}>
        <Spin indicator={<LoadingOutlined style={{ fontSize: 32, marginRight: 6 }} />} />
      </div>
    );
  }

  if (messagesFromThread.length === 0) {
    return (
      <div className={styles['emptyState']}>
        <div className={styles['emptyStateContent']}>
          <span>Nenhum chat ainda</span>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['messagesContainer']} id="chat-container">
      {[...messagesFromThread].map((message, index) => (
        <Message key={index} {...message} threadId={threadId} />
      ))}
    </div>
  );
};
